import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fullloader } from '../../../redux/action';
import { getMsgBy_Id, getMessageEventInfo } from '../../../redux/services';
import { selectedOrganizationSelector } from '../../../redux/selector';
import OpenActivity from '../../../Component/Analytics/Components/OpenActivity/OpenActivity';
import ClickActivity from '../../../Component/Analytics/Components/ClickActivity/ClickActivity';
import DeliveryActivity from '../../../Component/Analytics/Components/DeliveryActivity/DeliveryActivity';
import FailedDeliveryReport from '../../../Component/Analytics/Components/MessageAnalytics/Components/FailedDeliveryReport';
import SpamReport from '../../../Component/Analytics/Components/MessageAnalytics/Components/SpamReport';
import { convertToCSVFormat } from '../../../Component/Analytics/utils';
import { formatDate } from '../utils/status';
import { REPORT_TITLES, getReportRows } from '../utils/reports';

// Tiles whose drawer lists events from getMessageEventInfo.
const REPORT_TILES = ['bounce', 'drop', 'spam'];

// Opens the current Analytics page's drawer for a stat tile.
// openTileDrawer(message, tileKey, channel): channel is 'all', 'email' or
// 'text'. Under 'text', Delivery opens the text delivery activity and Bounce
// lists text bounces only, as on the current Text tab.
// Render `drawer` in the page.
const useStatDrawers = () => {
  const dispatch = useDispatch();
  const orgId = useSelector(selectedOrganizationSelector).id;
  // { tileKey, channel, message, reportRows } for the open drawer, or null.
  const [openDrawer, setOpenDrawer] = useState(null);

  const openTileDrawer = async (message, tileKey, channel) => {
    dispatch(fullloader(true, 'Loading...'));
    const fullMessage = await getMsgBy_Id(message._id, true);
    let reportRows = [];
    if (REPORT_TILES.includes(tileKey)) {
      const eventInfo = await getMessageEventInfo({
        msgId: message.id,
        BmessageId: message.AB?.linkedMessageId,
      });
      reportRows = getReportRows(tileKey, eventInfo, channel);
    }
    dispatch(fullloader(false));
    setOpenDrawer({ tileKey, channel, message: fullMessage, reportRows });
  };

  const closeDrawer = () => setOpenDrawer(null);

  const renderDrawer = () => {
    if (!openDrawer) return null;
    const { tileKey, channel, message, reportRows } = openDrawer;

    if (tileKey === 'delivery') {
      return (
        <DeliveryActivity
          initialMessage={message}
          orgId={orgId}
          isDeliveryActivityDrawerVisible
          setDeliveryActivityVisibility={closeDrawer}
          channel={channel === 'text' ? 'text' : 'email'}
        />
      );
    }
    if (tileKey === 'open') {
      return (
        <OpenActivity
          initialMessage={message}
          orgId={orgId}
          isOpenActivityDrawerVisible
          setOpenActivityVisibility={closeDrawer}
        />
      );
    }
    if (tileKey === 'clickThrough') {
      return (
        <ClickActivity
          initialMessage={message}
          isClickActivityVisible
          setClickActivityVisibility={closeDrawer}
        />
      );
    }

    const ReportDrawer = tileKey === 'spam' ? SpamReport : FailedDeliveryReport;
    return (
      <ReportDrawer
        onCloseDrawer={closeDrawer}
        isVisible
        isLoading={false}
        message={message}
        startDate={formatDate(message.sendTime)}
        data={reportRows}
        csvData={convertToCSVFormat(reportRows)}
        title={REPORT_TITLES[tileKey]}
      />
    );
  };

  return { openTileDrawer, drawer: renderDrawer() };
};

export default useStatDrawers;
